import * as React from 'react'
import type { RouteObject } from 'react-router'

const GenerateQR = React.lazy(
    () => import('../../common/views/QRRouter/GenerateQR'),
)

const QRContent = React.lazy(
    () => import('../../common/views/QRContent/QRContent'),
)

export const QRRouter: RouteObject[] = [
    {
        element: <GenerateQR />,
        path: '/generate-qr',
    },
    {
        element: <QRContent />,
        path: '/qr-content',
    },
]
